module.exports = __webpack_public_path__ + "img/51.db93c826.png";